import React from "react";
import "./mobilesolution1.css";

function MobileSolutions1() {
  return (
    <div className="ms-wrapper">

      <div className="container mobile-sol-sec">
        <h1 className="mobile-solution-heading">
          <strong>Mobile Solution</strong>
        </h1>

        <div className="row mobile-solution-row">

          {/* IMAGE */}
          <div className="col-lg-6 col-md-12">
            <div className="mobile-image-box">
              <img src="service-pic/mobilesolution.jpg" alt="Mobile Solution" />
            </div>
          </div>

          {/* CONTENT */}
          <div className="col-lg-6 col-md-12">
            <div className="mobile-content-card">
              <p>
                Developing and deploying effective mobility solutions using
                innovative web, mobile and cloud technologies. Enterprises today
                are chasing the mobile gold rush without completely understanding
                the difference between mobile and mobility.
              </p>

              <p>
                Mobility means optimizing customer experience by understanding
                behavior, goals and usage patterns. These insights become the
                foundation of powerful and scalable mobile solutions.
              </p>

              <button className="ms-btn">Explore More →</button>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
}

export default MobileSolutions1;